export { default } from "./fastDeepAssign.mjs";